/* RESPONSIBLE TEAM: team-messenger */
import type AppService from 'embercom/services/app-service';
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';
import type MessengerSettingsTargetUserProvider from 'embercom/services/messenger-settings-target-user-provider';
import type MessengerSettingsService from 'embercom/services/messenger-settings-service';
import type Transition from '@ember/routing/transition';
import { DEFAULT_SECTIONS_FOR_TABS, type Tab } from 'embercom/services/messenger-settings-service';
import type Router from '@ember/routing/router-service';
import type IntlService from 'ember-intl/services/intl';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

export default class MessengerWebRoute extends IntercomRoute {
  @service declare messengerSettingsTargetUserProvider: MessengerSettingsTargetUserProvider;
  @service declare MessengerSettingsService: MessengerSettingsService;
  @service declare router: Router;
  @service declare appService: AppService;
  @service declare finStandaloneService: FinStandaloneService;
  @service declare intl: IntlService;

  queryParams = {
    tab: {
      refreshModel: false,
      replace: true,
    },
    section: {
      refreshModel: false,
      replace: true,
    },
  };

  get titleToken() {
    return this.intl.t(`new-settings.submenu.channels.messenger`);
  }

  buildRouteInfoMetadata() {
    return {
      responsibleTeam: 'team-messenger',
    };
  }

  async beforeModel() {
    if (
      !this.messengerSettingsTargetUserProvider.isUserType &&
      !this.messengerSettingsTargetUserProvider.isVisitor
    ) {
      this.messengerSettingsTargetUserProvider.setVisitorTarget();
    }
    this.MessengerSettingsService.preview.onPlatformChange('web');
    if (this.appService.app.canUseStandalone) {
      await this.finStandaloneService.initialize();
    }
  }

  afterModel(model: any, transition: Transition) {
    if (model.settings.lookAndFeel.activeBrand === model.settings.lookAndFeel.mobileBrand) {
      model.settings.lookAndFeel.activeBrand = model.settings.lookAndFeel.defaultBrand;
    }

    let { tab, section } = transition.to.queryParams;
    tab ||= 'content';
    section ||= DEFAULT_SECTIONS_FOR_TABS[tab as Tab];
    this.MessengerSettingsService.settings = model.settings;
    this.MessengerSettingsService.navigate(tab as Tab, section, { changeUrl: false });
  }
}
